import supportedLocales from "@/services/supportedLocales";

export function supportedLocalesInclude(locale: any) {
    return Object.keys(supportedLocales).includes(locale)
}
